import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { GetAllDocument, GetSPInvoiceDetail } from '../../../API/GetData';
import { Button, DatePicker, Form, Input, InputNumber, message, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import { AuthData } from '../../../Components/Global';
import UploadFile from '../../MenuOrder/Order/Form/UploadFile';
import { UploadDocs } from '../../../API/PostData';
import TableFormUpload from '../Form/TableFormUpload';
import { UpdateInvoice } from '../../../API/UpdateData';
import { decrypt } from '../../../Utils/CryptoHelper';

const DetailInvoice = () => {
    const { accountid, code } = useParams();

    const DecAccountId = decrypt(decodeURIComponent(accountid));
    const DecCode = decrypt(decodeURIComponent(code));


    const navigate = useNavigate();
    const [form] = Form.useForm();
    const Auth = AuthData();

    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState(null);

    const [dataDocs, setDataDocs] = useState([]);

    const Status = Auth.Role === "Admin" ? false : true;


    useEffect(() => {
        const fetchDocs = async () => {
            const response = await GetAllDocument(DecAccountId, DecCode);

            const payload = response.map((item, index) => ({
                ...item,
                key: index + 1,
                FileUpload: `${process.env.REACT_APP_BASEURL}/${item.PathName}`
            }));
            setDataDocs(payload);
        };
        fetchDocs();

    }, [DecAccountId, DecCode]);

    // INVOICE DETAIL
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await GetSPInvoiceDetail(DecAccountId, DecCode);

                const payload = {
                    ...res,
                    InvoiceDate: dayjs(res.InvoiceDate),
                    InvoiceDueDate: dayjs(res.InvoiceDueDate),
                    InvoiceSentDate: dayjs(res.InvoiceSentDate),
                    PaymentDate: res.PaymentDate ? dayjs(res.PaymentDate) : ''
                }


                form.setFieldsValue({
                    ...payload
                });

            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, [DecAccountId, DecCode, form]);


    const handleSubmit = async (values) => {
        try {
            setLoading(true);

            const payload = {
                // ...values,
                PaymentDate: dayjs(values.PaymentDate).format("YYYY-MM-DD"),
                PaymentStatus: Auth.Role === "Admin" ? values.PaymentStatus : "PENDING REVIEW"
            };
            const res = await UpdateInvoice(DecAccountId, DecCode, payload);

            if (res.status !== 200) {
                throw new Error("Gagal mengirim data Invioce");
            }

            if (res.status === 200) {

                // Jika ada file, kirim file
                if (files) {
                    const [firstKey, firstValue] = files.entries().next().value;

                    const filePayload = new FormData();
                    filePayload.append('AccountId', DecAccountId);
                    filePayload.append('RefNo', payload.InvoiceCode);
                    filePayload.append('FileName', "BUKTI BAYAR");
                    filePayload.append('DocNo', dataDocs.length + 1);
                    filePayload.append('DocType', "BUKTI BAYAR");
                    filePayload.append(firstKey, firstValue);

                    const fileResponse = await UploadDocs(filePayload);

                    if (fileResponse.status !== 200) {
                        throw new Error("Gagal mengunggah file");
                    }

                    // console.log('File upload response:', fileResponse);
                }

                message.success(res.data.message);
                navigate('/dashboard/invoice');
            }

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h1 className="text-2xl">Upload Invoice</h1>

            <div className="bg-white p-4 w-full mt-4 rounded-md">
                <p className="border-b-2 pb-2 text-lg font-medium">Invoice Data</p>

                <Form
                    name="filterForm"
                    layout="vertical"
                    onFinish={handleSubmit}
                    autoComplete="off"
                    form={form}
                    className="mt-4 w-full"
                >

                    <div className="mx-2 my-2">
                        <p className="border-b-2 pb-2 text-xl mb-4">Basic Information</p>
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                            <Form.Item
                                label="Invoice Code"
                                name="InvoiceCode"
                            >
                                <Input placeholder="InvoiceCode" disabled />
                            </Form.Item>

                            <Form.Item
                                label="Invoice Date"
                                name="InvoiceDate"
                            >
                                <DatePicker className="w-full" disabled />
                            </Form.Item>

                            <Form.Item
                                label="Order Code"
                                name="OrderCode"
                            >
                                <Input placeholder="OrderCode" disabled />
                            </Form.Item>

                            <Form.Item
                                label="RF Number"
                                name="RFNumber"
                            >
                                <Input placeholder="RFNumber" disabled />
                            </Form.Item>

                            <Form.Item
                                label="Description"
                                name="Description"
                                className="lg:col-span-2"
                            >

                                <TextArea rows={4} placeholder="Description" disabled />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="ml-2 my-2">
                        <p className="border-b-2 pb-2 text-xl mb-4">Billing Information</p>

                        <Form.Item
                            label="Customer"
                            name="CustomerName"
                        >
                            <Input placeholder="Customer" disabled />
                        </Form.Item>

                        <Form.Item
                            label="Contact"
                            name="ContactPerson"
                        >
                            <Input placeholder="Contact" disabled />
                        </Form.Item>

                        <Form.Item
                            label="Address"
                            name="Address"
                        >
                            <TextArea rows={2} placeholder="Address" disabled />
                        </Form.Item>

                        <Form.Item
                            label="Invoice Sent Date"
                            name="InvoiceSentDate"
                        >
                            <DatePicker className="w-full" disabled />
                        </Form.Item>

                        <Form.Item
                            label="Email Address"
                            name="EmailContact"
                        >
                            <Input placeholder="Email Address" disabled />
                        </Form.Item>

                    </div>

                    <div className="ml-2 my-2">
                        <p className="border-b-2 pb-2 text-xl mb-4">Payment Information</p>

                        <Form.Item
                            label="Payment Status"
                            name="PaymentStatus"
                        >
                            <Select
                                placeholder="All Invoice Status"
                                options={[
                                    {
                                        value: 'UNPAID',
                                        label: 'UNPAID',
                                    },
                                    {
                                        value: 'PENDING REVIEW',
                                        label: 'PENDING REVIEW',
                                    },
                                    {
                                        value: 'REVISION NEEDED',
                                        label: 'REVISION NEEDED',
                                    },
                                    {
                                        value: 'PAID',
                                        label: 'PAID',
                                    },
                                    {
                                        value: 'REJECT',
                                        label: 'REJECT',
                                    },
                                ]}
                                disabled={Status}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Payment Date"
                            name="PaymentDate"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Payment Date!',
                                },
                            ]}
                        >
                            <DatePicker className="w-full" placeholder="Payment Date" />
                        </Form.Item>

                        <Form.Item
                            label="NET"
                            name="NET"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your NET!',
                                },
                            ]}
                        >
                            <InputNumber
                                placeholder="NET"
                                formatter={(value) =>
                                    `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                                }
                                parser={(value) =>
                                    value?.replace(/Rp\s?|(\.*)/g, '')
                                }
                                className="w-full"
                                disabled
                            />
                        </Form.Item>

                        {Auth.Role !== "Admin" && (
                            <Form.Item
                                label="Upload Payment"
                                name="Upload Payment"
                            >
                                <div className="flex flex-col gap-4">
                                    <UploadFile onFiles={(values) => setFiles(values)} />
                                </div>

                            </Form.Item>
                        )}

                        <TableFormUpload
                            // onSaveData={(values) => setDataDocs(values)}
                            onEditData={dataDocs}
                            onEditDetail={true}
                        />

                        {/* <InvoiceOrder dataSource={Order} /> */}

                        <div className="flex justify-end gap-2 mt-4 mb-2">
                            <Button type="primary" htmlType="submit" loading={loading}>Submit</Button>
                            <Link to={'/dashboard/invoice/'}>
                                <Button htmlType="submit">Cancel</Button>
                            </Link>
                        </div>

                    </div>

                </Form>


            </div>

        </div >
    )
}

export default DetailInvoice